import { db } from '../../firebase';
import firebase from 'firebase/app';
// xross interface
import { XROSS_USER_PROFILE, XROSS_PUBLIC_USER_INFO } from '$common/interface';
// コレクション名定義
import { CL_USER } from '../../common/define';
// ユーザ状態
import { _ACTIVE_ } from '../../common/define';

// types
export type MatchMode = 'equals' | 'prefix';
export type SearchCondition = { key: string; value: any; mode?: MatchMode };

/** lastData の受け取りを正規化（DocSnapshot を返す） */
const toCursorSnapshot = async (
  lastData: any | null
): Promise<firebase.firestore.DocumentSnapshot | null> => {
  if (!lastData) return null;

  // すでに DocumentSnapshot
  const isDocSnap =
    typeof lastData?.data === 'function' && typeof lastData?.get === 'function';
  if (isDocSnap) return lastData as firebase.firestore.DocumentSnapshot;

  // { id: string } が来た場合は取得して DocSnapshot 化
  if (lastData?.id) {
    const snap = await db.collection(CL_USER).doc(String(lastData.id)).get();
    return snap.exists ? snap : null;
  }

  // createdAt だけ持つ素オブジェクトなどは不安定なので null 扱いに
  return null;
};

/** 直接 Firestore を叩く最終版 */
export const getXrossUserList = async (
  limitNum: number,
  lastData: any | null,
  conditions: SearchCondition[] = [],
  defaultOrder: { field: string; dir?: firebase.firestore.OrderByDirection } = {
    field: 'createdAt',
    dir: 'desc',
  }
): Promise<XROSS_USER_PROFILE[]> => {
  try {
    // ① uid 完全一致が来たら doc 直取得（最速 & インデックス不要）
    const uidCond = conditions.find(
      (c) => (c.mode ?? 'equals') === 'equals' && c.key === 'uid' && c.value
    );
    if (uidCond) {
      const snap = await db
        .collection(CL_USER)
        .doc(String(uidCond.value))
        .get();
      if (!snap.exists) return [];
      return [{ id: snap.id, ...(snap.data() as any) } as XROSS_USER_PROFILE];
    }

    let q: firebase.firestore.Query = db.collection(CL_USER);

    // ② 条件分解
    const prefix = conditions.find(
      (c) => (c.mode ?? 'equals') === 'prefix' && c.key && c.value !== ''
    );

    // equals は 'uid' を除外（上で処理済み）
    const equalsList = conditions.filter(
      (c) =>
        (c.mode ?? 'equals') === 'equals' &&
        c.key &&
        c.value !== '' &&
        c.key !== 'uid'
    );

    // ③ equals 条件を積む（xrossUserStatus もここで反映。_ACTIVE_ をデフォルトで固定しない）
    for (const c of equalsList) {
      q = q.where(c.key, '==', c.value);
    }

    // ④ カーソル解決
    const cursorSnap = await toCursorSnapshot(lastData);

    // ⑤ 並びと範囲
    if (prefix && prefix.key) {
      // 前方一致：orderBy(prefix.key) のみ（createdAt は混ぜない）
      q = q.orderBy(prefix.key);
      if (cursorSnap) {
        q = q.startAfter(cursorSnap); // 2ページ目以降
      } else {
        q = q.startAt(prefix.value).endAt(prefix.value + '\uf8ff'); // 初回
      }
    } else {
      // 通常：既定順（createdAt desc など）
      q = q.orderBy(defaultOrder.field, defaultOrder.dir ?? 'asc');
      if (cursorSnap) q = q.startAfter(cursorSnap);
    }

    // ⑥ 件数
    q = q.limit(limitNum);

    const ss = await q.get();
    return ss.docs.map(
      (d) => ({ id: d.id, ...(d.data() as any) } as XROSS_USER_PROFILE)
    );
  } catch (e) {
    console.error('getXrossUserList error', e);
    return [];
  }
};
// export const getXrossUserList = async (
//   limitNum: number,
//   lastData: any | null,
//   conditions: SearchCondition[] = [],
//   defaultOrder: { field: string; dir?: firebase.firestore.OrderByDirection } = {
//     field: 'createdAt',
//     dir: 'desc',
//   }
// ): Promise<XROSS_USER_PROFILE[]> => {
//   try {
//     let q: firebase.firestore.Query = db.collection(CL_USER);

//     // 例：アクティブのみ
//     q = q.where('xrossUserStatus', '==', _ACTIVE_);

//     // 条件分解
//     const prefix = conditions.find(
//       (c) => (c.mode ?? 'equals') === 'prefix' && c.key
//     );
//     const equalsList = conditions.filter(
//       (c) => (c.mode ?? 'equals') === 'equals' && c.key && c.value !== ''
//     );

//     // equals 条件を積む（順序はカーディナリティ低→高が理想）
//     for (const c of equalsList) {
//       q = q.where(c.key, '==', c.value);
//     }

//     // 並びと範囲
//     const cursorSnap = await toCursorSnapshot(lastData);

//     if (prefix && prefix.key) {
//       // 前方一致：orderBy(prefix.key) + startAt/endAt or startAfter
//       q = q.orderBy(prefix.key);
//       if (cursorSnap) {
//         // 直前ページの最後の DocSnapshot をカーソルに
//         q = q.startAfter(cursorSnap);
//       } else {
//         q = q.startAt(prefix.value).endAt(prefix.value + '\uf8ff');
//       }
//     } else {
//       // 通常：createdAt など既定順
//       q = q.orderBy(defaultOrder.field, defaultOrder.dir ?? 'asc');
//       if (cursorSnap) q = q.startAfter(cursorSnap);
//     }

//     q = q.limit(limitNum);

//     const ss = await q.get();
//     return ss.docs.map(
//       (d) => ({ id: d.id, ...(d.data() as any) } as XROSS_USER_PROFILE)
//     );
//   } catch (e) {
//     console.error('getXrossUserList error', e);
//     return [];
//   }
// };

//
// firebase の uid から、xrossUserProfile を取得する
//
export const getXrossUserProfile = async (uid: string) => {
  console.log('getXrossUserProfile>> called ', uid);
  const docid = uid;
  try {
    const snapshot = await db.collection(CL_USER).doc(docid).get();
    const user = { ...snapshot.data(), id: docid } as XROSS_USER_PROFILE;
    // uid は、ドキュメントIDとして使用しているため、メンバーにセットする
    // console.log('user = ', user);
    return user;
  } catch (err) {
    console.log('getXrossUserProfile>> ', err);
    return null;
  }
};

//
// firebase の uid から、公開ユーザ情報を取得する
//
export const getPublicUserInfo = async (uid: string) => {
  console.log('getPublicUserInfo>> called');
  const docid = uid;
  try {
    const snapshot = await db.collection(CL_USER).doc(docid).get();
    const user = snapshot.data() as XROSS_PUBLIC_USER_INFO;
    user.id = docid; // uid は、ドキュメントIDとして使用しているため、メンバーにセットする
    if (user.xrossUserStatus !== _ACTIVE_) {
      return null;
    } else {
      return user;
    }
  } catch (err) {
    console.log('getPublicUserInfo>> ', err);
    return null;
  }
};

//
// ユーザ情報を更新する
//
export const updateUser = async (uid: string, params: any) => {
  const docRef = db.collection(CL_USER).doc(uid);
  const timestamp = firebase.firestore.FieldValue.serverTimestamp();
  try {
    if (!(await docRef.get()).exists) {
      docRef.set({
        xrossUserID: '',
        xrossUserName: '',
        xrossAvatarURL: '',
        xrossUserStatus: '_ACTIVE_',
        profile: '',
        homeGLocation: null,
        homeGLocationLabel: '',
        isDefaultLocationAtHome: false,
        defaultPostDisclosureRange: '_BETWEEN_FRIENDS_',
        createdAt: timestamp,
        lastRefreshAt: timestamp,
      });
    }
  } catch (e) {
    console.log('updateUser setup e=', e);
  }

  try {
    const updateParems = {
      ...params,
      lastRefreshAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
    await db.collection(CL_USER).doc(uid).update(updateParems);
  } catch (e) {
    console.log('updateUser e=', e);
  }
};

//
// プッシュトークンを更新する
//
export const updatePushToken = async (uid: string, pushToken: string) => {
  await db
    .collection(CL_USER)
    .doc(uid)
    .update({
      pushToken: firebase.firestore.FieldValue.arrayUnion(pushToken),
      lastRefreshAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
};

//
// プッシュトークンを削除する
//
export const removePushToken = async (uid: string, pushToken: string) => {
  await db
    .collection(CL_USER)
    .doc(uid)
    .update({
      pushToken: firebase.firestore.FieldValue.arrayRemove(pushToken),
    });
};

//
// firebase の XrossUSerProfile を強制的に全更新する
//
export const updateXrossUserForce = async (
  xrossUserProfile: XROSS_USER_PROFILE
) => {
  try {
    const userRef = db.collection(CL_USER).doc(xrossUserProfile.id);
    console.log('updateXrossUserForce>> called uid = ', xrossUserProfile.id);

    await userRef.update({
      xrossUserID: xrossUserProfile.xrossUserID,
      xrossUserName: xrossUserProfile.xrossUserName,
      xrossAvatarURL: xrossUserProfile.xrossAvatarURL,
      xrossUserStatus: xrossUserProfile.xrossUserStatus,
      profile: xrossUserProfile.profile,
      homeGLocation: xrossUserProfile.homeGLocation,
      homeGLocationLabel: xrossUserProfile.homeGLocationLabel,
      isDefaultLocationAtHome: xrossUserProfile.isDefaultLocationAtHome,
      defaultPostDisclosureRange: xrossUserProfile.defaultPostDisclosureRange,
      lastRefreshAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
  } catch (err) {
    console.log(`Error: ${JSON.stringify(err)}`);
  }
};

//
//ユーザ登録数を取得する
//
export const getXrossUserNum = async () => {
  console.log('getXrossUserNum>> called');

  try {
    const snapshot = await db.collection('xrossUser').get();
    console.log(snapshot.size);
    console.log(snapshot.empty);
    console.log('user num = ', snapshot.size);
    return snapshot.size;
  } catch (err) {
    console.log('getXrossUserNum>> ', err);
    return 0;
  }
};
